"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _QRReaderNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/QRReaderNugget"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _QRCode = require("../../../../helpers/QRCode");

var _Button = _interopRequireDefault(require("../../Button"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'qrReaderButtonContainer_';

var DrupalEkgNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalEkgNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalEkgNugget);

  function DrupalEkgNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalEkgNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    _this.state = _objectSpread({}, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _QRReaderNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalEkgNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalEkgNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log('render ekg nugget');
      this.registerNuggetPosition(this.props.id, _QRReaderNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEkgNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var caption = nugget.button_caption;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "qrReaderContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'header',
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'button',
        style: {
          position: 'absolute',
          right: 0,
          background: 'red'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], null, "Hallo")))));
    }
  }]);
  return DrupalEkgNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalEkgNugget;
DrupalEkgNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  region: _propTypes["default"].string,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalEkgNugget.defaultProps = {
  id: null
};